import { render, staticRenderFns } from "./homecharts.vue?vue&type=template&id=2cbddc9a"
import script from "./homecharts.vue?vue&type=script&lang=js"
export * from "./homecharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports